import flarebase from 'flarebase'


class LoynAuth extends flarebase.auth.Auth {
  constructor() {
    super();
  }

}

var auth = new LoynAuth();

auth.on('result', async (result) => {
  if (!result.user) return;

  // TODO: SNS ログイン時の対応

});

// auth.on('fail', (e) => {
//   spat.modal.alert(e.message);
// });


export default auth;